import ShareSheetModal, { ShareSheetModalBlockProps } from './ShareSheetModalBlock';
import withInteractor from './ShareSheetModalBlock.interactor';
import withPresenter from './ShareSheetModalBlock.presenter';

export type { ShareSheetModalBlockProps };
export default withInteractor(withPresenter(ShareSheetModal))